import { ajax } from 'rxjs/ajax';
import { catchError, map, switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  ApproveReportInput,
  CompleteBatchReportUploadInput,
  DeleteReportInput,
  DownloadReportInput,
  GeneratePresignedUrlInput,
  GenerateReportAsyncInput,
  InitiateBatchReportUploadInput,
  RejectReportInput,
  SearchReportsInput,
  UploadReportInput,
} from '@amzn/coral_com-amazon-transreportscenterservice';
import TransReportsCenterServiceClient from '../clients/TransReportsCenterServiceClient';
import isSiteExternal from '../utils/isSiteExternal';

export function searchReports({
  term,
  reportType,
  lpAttributesKey,
  pageSize,
  logisticsPartyId,
  searchCriteria,
  sortCriteriaList,
  offset,
}: SearchReportsInput) {
  const searchReportsInput = SearchReportsInput.clone({
    offset,
    term,
    reportType,
    lpAttributesKey,
    pageSize,
    searchCriteria,
    sortCriteriaList,
    ...(!isSiteExternal() ? { logisticsPartyId } : {}),
  });
  return TransReportsCenterServiceClient.searchReports(searchReportsInput);
}

export function downloadReport({
  reportId,
  reportType,
  term,
  logisticsPartyId,
}: DownloadReportInput) {
  const downloadReportInput = DownloadReportInput.clone({
    reportId,
    reportType,
    term,
    logisticsPartyId,
  });
  return TransReportsCenterServiceClient.downloadReport(downloadReportInput);
}

export function getTermReportConfigs() {
  return TransReportsCenterServiceClient.getTermReportConfigs({});
}

export function initiateBatchReportUpload(
  initiateBatchReportUploadInput: InitiateBatchReportUploadInput
) {
  return TransReportsCenterServiceClient.initiateBatchReportUpload(
    initiateBatchReportUploadInput
  );
}

export function completeBatchReportUpload(
  completeBatchReportUploadInput: CompleteBatchReportUploadInput
) {
  return TransReportsCenterServiceClient.completeBatchReportUpload(
    completeBatchReportUploadInput
  );
}

export function uploadReport(uploadReportInput: UploadReportInput) {
  return TransReportsCenterServiceClient.uploadReport(uploadReportInput);
}

export const deleteReport = (deleteReportInput: DeleteReportInput) => {
  return TransReportsCenterServiceClient.deleteReport(deleteReportInput);
};

export const uploadWithS3PresignedUrl = ({ s3presignedUrl, file }) =>
  ajax({
    method: 'PUT',
    url: s3presignedUrl,
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    body: file,
  }).pipe(
    map((response) => response),
    catchError((err) => of(false))
  );

export const generateReportAsync = (
  generateReportAsyncInput: GenerateReportAsyncInput
) => {
  return TransReportsCenterServiceClient.generateReportAsync(
    generateReportAsyncInput
  );
};

export const generatePresignedUrl = (
  generatePresignedUrlInput: GeneratePresignedUrlInput
) => {
  return TransReportsCenterServiceClient.generatePresignedUrl(
    generatePresignedUrlInput
  );
};

export const downloadWithS3PresignedUrl = ({ presignedUrl }) =>
  ajax({
    url: presignedUrl,
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    responseType: 'text',
  }).pipe(
    map((response) => {
      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }
      const csvData = response.response;
      return csvData;
    }),
    catchError(() => of(false))
  );

export const approveReport = (approveReportInput: ApproveReportInput) => {
  return TransReportsCenterServiceClient.approveReport(approveReportInput);
};

export const rejectReport = (rejectReportInput: RejectReportInput) => {
  return TransReportsCenterServiceClient.rejectReport(rejectReportInput);
};
